module.exports = __webpack_public_path__ + "static/img/Send6.0c533f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send6.png
// module id = unCb
// module chunks = 0